import { render, staticRenderFns } from "./UrlField.vue?vue&type=template&id=1bfd2977&"
import script from "./UrlField.vue?vue&type=script&lang=ts&"
export * from "./UrlField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports